module.exports = __webpack_public_path__ + "static/media/calendar.3578b4bf.svg";